<div class="section-title">
    <span class="sub-title">{{ 'FAQ.TITLE' | translate }}</span>
    <h2>{{ 'FAQ.SUBTITLE' | translate }}</h2>
</div>

<div class="row justify-content-center mb-4">
    <div class="col-md-4">
        <form>
            <div class="form-group">
                <select (change)="selectFaqCat($event.target.value)" 
                        id="idcatfaq" 
                        class="form-control">
                    <option value="0">{{ 'FAQ.SELECT_CATEGORY' | translate }}</option>
                    <option *ngFor="let c of cats" 
                            value="{{c?.idcategoriefaq}}">
                        {{c.nomcategoriefaq}}
                    </option>
                </select>
            </div>
        </form>
    </div>
</div>

<nb-layout>
    <nb-layout-column class="colored-column-info">
        <nb-card [nbSpinner]="loading" 
                nbSpinnerStatus="success" 
                nbSpinnerSize="giant"
                [nbSpinnerMessage]="'FAQ.LOADING' | translate">
            <nb-card-body>
                <div class="row">
                    <!-- Première colonne de questions -->
                    <div class="col-md-6">
                        <div class="tab-content">
                            <nb-accordion multi class="tab-iten">
                                <nb-accordion-item *ngFor="let faq of FAQS | slice:0:10"
                                                 class="card faq-accordion-content">
                                    <nb-accordion-item-header class="card-header" role="tab">
                                        {{faq.questionfaq}}
                                    </nb-accordion-item-header>
                                    <nb-accordion-item-body class="" role="tabpanel">
                                        {{faq.reponsefaq}}
                                    </nb-accordion-item-body>
                                </nb-accordion-item>
                            </nb-accordion>
                        </div>
                    </div>

                    <!-- Deuxième colonne de questions -->
                    <div class="col-md-6">
                        <div class="tab-content">
                            <nb-accordion multi class="tab-iten">
                                <nb-accordion-item *ngFor="let faq of FAQS | slice:10:20"
                                                 class="card faq-accordion-content">
                                    <nb-accordion-item-header class="card-header" role="tab">
                                        {{faq.questionfaq}}
                                    </nb-accordion-item-header>
                                    <nb-accordion-item-body class="" role="tabpanel">
                                        {{faq.reponsefaq}}
                                    </nb-accordion-item-body>
                                </nb-accordion-item>
                            </nb-accordion>
                        </div>
                    </div>
                </div>

                <!-- Message si aucune question n'est disponible -->
                <div *ngIf="FAQS.length === 0" class="text-center mt-4">
                    {{ 'FAQ.NO_QUESTIONS' | translate }}
                </div>
            </nb-card-body>
        </nb-card>
    </nb-layout-column>
</nb-layout>